module.exports = __webpack_public_path__ + "img/image02.d7d316aa.jpg";